import { render, staticRenderFns } from "./ImportConversations.vue?vue&type=template&id=610e28f7&"
import script from "./ImportConversations.vue?vue&type=script&lang=js&"
export * from "./ImportConversations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports